import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";

import { themeContext } from "../../Context";
import { scrollContext } from "../../scrollctx/ctx";
import { useEffect } from "react";
import { useRef } from "react";
import portfolioitems from "./portfolioitems";
const Portfolio = () => {
  const portfolioPosRef = useRef();
  const { setPortfolioPos } = useContext(scrollContext);
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  useEffect(() => {
    setPortfolioPos(portfolioPosRef.current.offsetTop);
  }, []);
  return (
    <div ref={portfolioPosRef} className="portfolio" id="portfolio">
      {/* heading */}
      <div className="portfolio-heading">
        <span className="portfolio-title" style={{ color: darkMode ? "white" : "" }}>Recent Projects</span>
        <span className="portfolio-subtitle">Portfolio</span>
      </div>

      {/* slider */}
      <Swiper
        spaceBetween={30}
        modules={[Navigation, Pagination, Scrollbar, A11y]}
        pagination={{ clickable: true }}
        slidesPerView={
          window.innerWidth > 1100 ? 3 : window.innerWidth > 750 ? 2 : 1
        }
        grabCursor={true}
        className="portfolio-slider"
      >
        {portfolioitems.map((v, index) => (
          <SwiperSlide key={index + "portfolionin"}>
            <div className={`portfolio-card ${darkMode ? "portfolio-card--dark" : ""}`}>
              <div className="portfolio-card__image-wrapper">
                <img src={v.image} alt={v.name} />
                <div className="portfolio-card__overlay">
                  <a href={v.link} target="_blank" rel="noopener noreferrer">
                    View Live &rarr;
                  </a>
                </div>
              </div>
              <div className="portfolio-card__content">
                <h3 className="portfolio-card__title">{v.name}</h3>
                <p className="portfolio-card__desc">{v.description}</p>
                <div className="portfolio-card__tags">
                  {v.tags.map((tag, i) => (
                    <span key={i} className="portfolio-card__tag">{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Portfolio;
